
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ExternalLink, MessageCircle, ThumbsUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePostsStore } from "@/store/postsStore";
import { formatDate, truncateText } from '@/lib/utils';

export const RecentPosts = () => {
  const { posts } = usePostsStore();
  const navigate = useNavigate();

  // Get the 3 most recent posts
  const recentPosts = [...posts]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 3);

  if (recentPosts.length === 0) {
    return null;
  }

  return (
    <Card className="border-blue-100 mb-6">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-medium flex items-center justify-between">
          <span>Recent Community Posts</span>
          <Button 
            variant="link" 
            className="text-sky-600 p-0 h-auto"
            onClick={() => navigate('/posts')}
          >
            View All <ExternalLink className="h-3 w-3 ml-1" />
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {recentPosts.map(post => (
          <div 
            key={post.id}
            className="p-3 bg-gradient-to-r from-sky-50 to-emerald-50/50 rounded-lg cursor-pointer hover:shadow-sm transition-all"
            onClick={() => navigate('/posts')}
          >
            <div className="flex justify-between mb-1">
              <h4 className="font-medium text-gray-900">{truncateText(post.title, 40)}</h4>
              <span className="text-xs text-gray-500">{formatDate(post.createdAt)}</span>
            </div>
            <p className="text-sm text-gray-700 mb-2">
              {truncateText(post.content, 80)}
            </p>
            
            <div className="flex items-center justify-between">
              <div className="flex gap-1">
                {post.tags.slice(0, 2).map((tag, i) => (
                  <Badge key={i} variant="outline" className="text-xs bg-white/80 border-blue-100">
                    {tag}
                  </Badge>
                ))}
                {post.tags.length > 2 && (
                  <Badge variant="outline" className="text-xs bg-white/80 border-blue-100">
                    +{post.tags.length - 2}
                  </Badge>
                )}
              </div>
              
              <div className="flex items-center gap-3 text-xs text-gray-500">
                <div className="flex items-center">
                  <ThumbsUp className="h-3 w-3 mr-1" />
                  {post.likes}
                </div>
                <div className="flex items-center">
                  <MessageCircle className="h-3 w-3 mr-1" />
                  {post.comments.length}
                </div>
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
